import { useState, useEffect } from 'react'
import './Pages.css'
import './Listen.css'

const videos = [
    {
        thumbnail: '/images/listen/EGC09419A.webp',
        title: 'Silent Night (Joel Love)',
        type: 'youtube',
        embedId: 'ioZ7gMx1X0Q',
        imagePosition: 'left'
    },
    {
        thumbnail: '/images/listen/EGC09430A.webp',
        title: 'Immeasurable (Scott McLaren)',
        type: 'youtube',
        embedId: 'tYeuD5w5ns8',
        imagePosition: 'left bottom',
        imageScale: 1.2
    },
    {
        thumbnail: '/images/listen/insta1.webp',
        title: 'Merry Go Round of Life (Joe Hisaishi) - Live',
        type: 'media',
        src: '/media/KazokuatPark.MOV',
    },
    {
        thumbnail: '/images/listen/DSC05479.webp',
        title: 'Graceful Ghost Rag (Bolcolm, arr. Gelok) - Live',
        type: 'media',
        src: '/media/GGRag.mp3',
        imagePosition: 'center top'
    },
]


function Listen() {
    const [active, setActive] = useState(null)

    useEffect(() => {
        if (!active) return
        const handleKey = (e) => {
            if (e.key === 'Escape') setActive(null)
        }
        document.body.style.overflow = 'hidden'
        window.addEventListener('keydown', handleKey)
        return () => {
            document.body.style.overflow = ''
            window.removeEventListener('keydown', handleKey)
        }
    }, [active])

    return (
        <div className="page">
            <h1>Listen</h1>
            <div className='listen-grid'>
                {videos.map((video) => (
                    <button
                        className="listen-card"
                        key={video.title}
                        onClick={() => setActive(video)}
                    >
                        <div className="listen-thumbnail-wrap">
                            <img src={video.thumbnail} alt={video.title} className="listen-thumbnail" style={{ ...(video.imagePosition && { objectPosition: video.imagePosition }), ...(video.imageScale && { transform: `scale(${video.imageScale})`, transformOrigin: video.imagePosition || 'center center' }) }} />
                        </div>
                        <span className='listen-title'>{video.title}</span>
                    </button>
                ))}
            </div>

            {active && (
                <div className="listen-modal-overlay" onClick={() => setActive(null)}>
                    <div className="listen-modal" onClick={(e) => e.stopPropagation()}>
                        <button className="listen-modal-close" onClick={() => setActive(null)}>
                            &times;
                        </button>
                        <div className="listen-modal-content">
                            {active.type === 'youtube' ? (
                                <iframe
                                    src={`https://www.youtube.com/embed/${active.embedId}?autoplay=1`}
                                    title={active.title}
                                    className="listen-modal-iframe"
                                    allow="autoplay; encrypted-media"
                                    allowFullScreen
                                />
                            ) : (
                                <video
                                    ref={(el) => {
                                        if (!el) return
                                        setTimeout(() => el.play(), 600)
                                    }}
                                    src={active.src}
                                    controls
                                    className="listen-modal-video"
                                >
                                    Your browser does not support the video element.
                                </video>
                            )}
                        </div>
                        <p className="listen-modal-title">{active.title}</p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Listen;
